// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Location INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, uniqueId } from 'lodash';
import { Icon } from '@unite-us/ui';
import AllOrOne from "../../AllOrOne";
import EmailAddress from "../../contact/EmailAddress";
import HoursOfOperationV2 from "../../hours/HoursOfOperationV2";
import addresses from "../../utils/addresses";
import phones from "../../utils/phones";

/**
 * @visibleName Location DEPRECATED
*/

var Location = function Location(_ref) {
  var addressCount = _ref.addressCount,
    className = _ref.className,
    clickableAddress = _ref.clickableAddress,
    disableEmailLink = _ref.disableEmailLink,
    disablePhoneLink = _ref.disablePhoneLink,
    hideLabels = _ref.hideLabels,
    isInNetworkGroup = _ref.isInNetworkGroup,
    locationData = _ref.location,
    originLatLng = _ref.originLatLng,
    showHours = _ref.showHours,
    showHoursIcon = _ref.showHoursIcon,
    showMore = _ref.showMore,
    stopEventPropagation = _ref.stopEventPropagation,
    additionalContentComponent = _ref.additionalContentComponent,
    intlProvider = _ref.intlProvider;
  var location = addresses.calculateDistance(locationData, originLatLng);
  var locationAddress = function locationAddress(loc) {
    return !isEmpty(originLatLng) ? "".concat(loc.displayName, " (").concat(loc.distance, ")") : "".concat(loc.displayName);
  };
  var locationAddressWithLink = function locationAddressWithLink() {
    return clickableAddress ? /*#__PURE__*/React.createElement("a", {
      href: addresses.makeGoogleMapLink(location),
      rel: "noopener noreferrer",
      target: "_blank",
      className: "ui-locations-address-link"
    }, locationAddress(location)) : locationAddress(location);
  };
  var formattedPhoneNumber = function formattedPhoneNumber(phoneNumber) {
    return !hideLabels && phoneNumber.phone_type ? "".concat(phoneNumber.phone_type, ": ").concat(phones.formatPhoneNumber(phoneNumber.phone_number)) : phones.formatPhoneNumber(phoneNumber.phone_number);
  };
  var AdditionalContentComponent = additionalContentComponent;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line
    React.createElement("div", {
      className: "ui-location ".concat(className),
      onClick: function onClick(e) {
        if (stopEventPropagation) {
          e.stopPropagation();
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "ui-location__address",
      key: uniqueId(location.name || location.displayName)
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "ui-location__icon mr-half",
      color: "".concat(isInNetworkGroup ? '#4571BA' : '#2C405A'),
      icon: "IconMapMarkV2",
      size: 18
    }), /*#__PURE__*/React.createElement("div", {
      className: "ui-location__content pl-quarter"
    }, !hideLabels && location.name ? location.name : /*#__PURE__*/React.createElement("p", {
      className: "ui-location__address-name"
    }, /*#__PURE__*/React.createElement("span", {
      className: "mr-half"
    }, locationAddressWithLink(location)), /*#__PURE__*/React.createElement("span", {
      className: "ui-location__address-name-more"
    }, !isEmpty(addressCount) ? addressCount : '')), !hideLabels && location.name && /*#__PURE__*/React.createElement("p", {
      className: "ui-location__address"
    }, /*#__PURE__*/React.createElement("span", {
      className: "mr-half"
    }, locationAddressWithLink(location)), /*#__PURE__*/React.createElement("span", {
      className: "ui-location__address-name-more"
    }, !isEmpty(addressCount) ? addressCount : '')), /*#__PURE__*/React.createElement(AllOrOne, {
      showAll: showMore
    }, !isEmpty(location.phone_numbers) && location.phone_numbers.map(function (phoneNumber) {
      return /*#__PURE__*/React.createElement("p", {
        key: "phone-".concat(phoneNumber.phone_number),
        className: "ui-location__phone"
      }, disablePhoneLink ? formattedPhoneNumber(phoneNumber) : /*#__PURE__*/React.createElement("a", {
        href: phones.getTelLink(phoneNumber),
        target: "_blank",
        tabIndex: 0,
        rel: "noopener noreferrer"
      }, formattedPhoneNumber(phoneNumber)));
    })), /*#__PURE__*/React.createElement(AllOrOne, {
      showAll: showMore
    }, !isEmpty(location.email_addresses) && location.email_addresses.map(function (email) {
      return /*#__PURE__*/React.createElement("p", {
        className: "ui-location__email",
        key: "email-".concat(email)
      }, /*#__PURE__*/React.createElement(EmailAddress, {
        className: "program-details__email-text",
        disableLink: disableEmailLink,
        emailAddress: email
      }));
    })))), showHours && /*#__PURE__*/React.createElement("div", {
      className: "ui-location__hours"
    }, /*#__PURE__*/React.createElement(HoursOfOperationV2, {
      hours: location.hours || location.hours_of_operation,
      isInNetworkGroup: isInNetworkGroup,
      showAll: showMore,
      showHoursIcon: showHoursIcon,
      showToggle: true,
      intlProvider: intlProvider
    })), additionalContentComponent && /*#__PURE__*/React.createElement(AdditionalContentComponent, {
      location: location
    }))
  );
};
Location.propTypes = {
  addressCount: PropTypes.string,
  className: PropTypes.string,
  clickableAddress: PropTypes.bool,
  disableEmailLink: PropTypes.bool,
  disablePhoneLink: PropTypes.bool,
  hideLabels: PropTypes.bool,
  isInNetworkGroup: PropTypes.bool,
  location: PropTypes.object.isRequired,
  originLatLng: PropTypes.array,
  showHours: PropTypes.bool,
  showHoursIcon: PropTypes.bool,
  showMore: PropTypes.bool,
  stopEventPropagation: PropTypes.bool,
  /**
   * Property to pass a component that will render in the main content area of the component.
   * This feature is used to render an edit location link.
   */
  additionalContentComponent: PropTypes.func,
  intlProvider: PropTypes.object
};
Location.defaultProps = {
  addressCount: null,
  className: '',
  clickableAddress: false,
  disableEmailLink: false,
  disablePhoneLink: false,
  hideLabels: false,
  isInNetworkGroup: true,
  originLatLng: [],
  showHours: true,
  showHoursIcon: false,
  showMore: false,
  stopEventPropagation: false,
  additionalContentComponent: null,
  intlProvider: {}
};
export default Location;